export default "__VITE_ASSET__tqbRmE5U__"